import { useEvents } from "@shapeable/ui";
import { isOpportunityEvent } from "../types";
import { transformEvent } from "../utils/transforms";

export const useOpportunities = () => (useEvents().filter(isOpportunityEvent).map(transformEvent));